import React from 'react';

import DashboardCards from '../AdminDashboards/DashboardCards';
import {
  COMMUNITY_ADMIN_PATH,
  communityAdminTools,
  toolsWithBasePath
} from '../AdminDashboards/adminTools';

export default function() {
  return <DashboardCards
    title="Community Admin"
    intro="Welcome, Community Admin! Select a tool to get started."
    cards={toolsWithBasePath(communityAdminTools, COMMUNITY_ADMIN_PATH)}
  />
};
